import React from 'react'
import styled from 'styled-components'
import Categories from '../Categories'
import Title from './Title'
const BannerCategories = () => {
  return (
    <Wrapper>
      {/* <Title title="categories" /> */}
      {/* <Categories /> */}
    </Wrapper>
  )
}
const Wrapper = styled.div`
  .categories {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .category {
    font-size: 1rem;
    color: var(--clr-grey-5);
    text-transform: capitalize;
    /* display: inline-block; */
    /* flex-direction: row; */

    padding: 0.5rem 0 0.5rem 1rem;
    letter-spacing: var(--spacing);
    transition: var(--transition);
    border-radius: var(--radius);
    /* width: 100%; */
  }
  .category:hover {
    background: var(--clr-grey-10);
  }
  @media (min-width: 768px) {
    .categories {
      display: flex;
      margin-bottom: 16px;
      justify-content: center;
      align-items: center;
    }
    .category {
      font-size: 1rem;
      color: var(--clr-grey-5);
      text-transform: capitalize;
      /* display: inline-block; */
      /* flex-direction: row; */

      padding: 0.5rem 0 0.5rem 1rem;
      letter-spacing: var(--spacing);
      transition: var(--transition);
      border-radius: var(--radius);
      /* width: 100%; */
    }
    .category:hover {
      background: var(--clr-grey-10);
    }
  }
`
export default BannerCategories
